import React, {Component} from 'react';

import {UserSettings} from "./UserSettings";
import {withRouterParams} from "../../utils/withRouterParams";

class UserConfiguration extends Component {
    render() {
        return (
            <UserSettings userId={this.props.match.params.id}/>
        )
    }
}

export default withRouterParams(UserConfiguration);

